<template>
	<div>
		<div v-for="(item, index) in list" :key="index"  class="iconList">
			<div v-if="item.isShow ? item.isShow(item) : true" @click="onClick(item)" >
			<div class="img"><img :src="item.imgsrc" class="imgsrc"/></div>
			<div>{{ item.text }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		list: null,
	},
	data() {
		return {};
	},
	components: {},
	computed: {},
	methods: {
		onClick(item) {
			console.log("click",item);
			if (item.onClick) {
				item.onClick();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.img{
	width: 40px;
	height: 40px;
	background: #F5F5F5;
	border-radius: 50%;
	text-align: center;
	line-height: 50px;
	display:inline-block;
}
.imgsrc{
	width: 20px;
	height: 20px;
}
.iconList{
  text-align: center;
  font-weight: 400;
color: #333333;
font-size: 8px;
margin: 20px 0px;
cursor: pointer;
}
</style>
